module.exports = __webpack_public_path__ + "assets/baidu-analytics.db91ed76.svg";